<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button" v-on:click="confirm()" :class="{'disabled-btn': groupsExistsCount <= 1}">
            <SVGPhotoDelete class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Удалить группу</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="editSelectedGroup()" v-show="routeName === 'groupingPlanesActive'">
            <SVGAdminEditRow class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Редактировать группу</span>
        </div>
    </div>
</template>

<script>
    import SVGPhotoDelete from "../../SVG/SVGPhotoDelete";
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow";
    import {bus} from "../../../vue_bus";
    import ModalConfirmation from "../../Modal/ModalConfirmation";

    export default {
        name: "LeftLowerBarGroupOptions",
        components: {
            SVGAdminEditRow,
            SVGPhotoDelete
        },
        computed: {
            routeName() {
                return this.$store.state.route.name;
            },
            groupsExistsCount() {
                return Object.keys(this.$store.getters['active/PLANE_GROUP_LIST']).length
            }
        },
        methods: {
            deleteSelectedGroup() {
                return async () => {
                    if (this.groupsExistsCount > 1) {
                        await this.$store.dispatch('active/DELETE_PLANE_GROUP');
                        bus.$emit('refreshFabric');
                        if (this.routeName !== 'groupingPlanes') {
                            this.$router.replace({
                                name: 'groupingPlanes',
                                query: this.$route.query,
                            }).catch(() => {
                            });
                        }
                    }
                }
            },
            confirm() {
                const title = 'Удалить выбранную группу?'
                const text = 'Плоскости будут разгруппированы, применённые к ним текстуры будут сброшены, Вы уверены, что хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteSelectedGroup()}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            editSelectedGroup() {
                this.$router.push({
                    name: 'groupingPlanesActiveEditGroup',
                    query: this.$route.query,
                }).catch(() => {});
            }
        }
    }
</script>

<style scoped>
    .disabled-btn {
        cursor: no-drop;
        color: #cccccc !important;
    }
</style>

